export const getBadgeOverrides = theme => {
  return {
    MuiBadge: {
      styleOverrides: {
        badge: {
          backgroundColor: theme.palette.error.main
        },
        dot: {
          width: 8,
          height: 8,
          left: 12,
          top: 4
        },
        standard: {
          minWidth: 16,
          height: 16,
          padding: 0,
          color: theme.palette.background.white,
          fontWeight: 400,
          fontSize: 10
        }
      }
    }
  };
};